import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

function ScenarioList() {
  const { t } = useTranslation()
  return (
    <Container>
      <Row className="mb-4">
        <Col>
          <h1 style={{ color: 'var(--color-primary-dark)' }}>{t('scenario_list.title')}</h1>
          <p className="text-secondary">
            {t('scenario_list.subtitle')}
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card
            className="shadow-sm"
            style={{ borderTop: '3px solid var(--color-primary)' }}
          >
            <Card.Body>
              <Card.Title style={{ color: 'var(--color-primary-dark)' }}>
                📋 {t('scenario_list.card_title')}
              </Card.Title>
              <Card.Text style={{ color: 'var(--color-text)' }}>
                {t('scenario_list.card_text')}
              </Card.Text>
              <ul style={{ color: 'var(--color-text-secondary)' }}>
                <li>{t('scenario_list.bullet_create')}</li>
                <li>{t('scenario_list.bullet_edit')}</li>
                <li>{t('scenario_list.bullet_clone')}</li>
                <li>{t('scenario_list.bullet_history')}</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default ScenarioList
